// extracted by mini-css-extract-plugin
export default {"container":"_n-z","heading":"ao-z","text":"bo-z","info":"co-z","link":"do-z","fullMaxWidth":"eo-z"};